import { useEffect, useRef } from "react";

export function useClickAway(onClickAway, enabled = true) {
  const ref = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClickAway(e);
      }
    };

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [onClickAway, enabled]);

  return ref;
}
